import { Box, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

export default function StaticLabelDivider({ children }: PropsWithChildren) {
    return (
        <Typography variant="heading" className={'heading-item'}>
            <Box component={'span'} className={'heading-item__label'}>
                {children}
            </Box>
        </Typography>
    );
}
